<template>
  <div>
    <div v-if="disabled" class="mb-6">
    <FieldText :namespace="namespace" :field="field" :label="label" :placeholder="placeholder" :disabled="true"></FieldText>
  </div>
  <div v-else class="mb-6">
    <Label :label="label"></Label>
    <div class="w-full relative">
      <!-- <img src="@/assets/location.svg" class="absolute input-icon-position" alt="location icon"/> -->
      <input
        :id="field"
        autocomplete="off"
        :class="`w-full field border-grey-lighter ${!errors.has(field) && 'border-grey-lighter'} ${errors.has(field) && 'border-red'}`"
        class="c-base-field c-base-field-icon"
        placeholder="Start typing..."
        type="text"
        :name="field"
        :aria-labelled-by="field"
        v-validate="validationRule"
        v-model="fieldModel"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
      />
    </div>
    <div class="flex justify-between relative">
      <p class="text-red text-xs italic mt-3 w-1/2" v-show="errors.has(field)">{{validationMessage}}</p>
      <div class="flex items-center absolute pin-r mt-2">
        <span class="mr-2 text-grey-dark font-normal">No Address Found</span>
        <svg v-tooltip="addressToolTip" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="help/icon" transform="translate(1.000000, 1.000000)">
              <g id="Group-2-Copy-6">
                <g id="Group-Copy" fill="#FFFFFF" stroke="#E5EDED" stroke-width="0.968">
                  <rect id="Rectangle-6" x="0" y="0" width="27.5968" height="27.5968" rx="13.7984"></rect>
                </g>
                <text id="?" font-family="AvenirNext-DemiBold, Avenir Next" font-size="15.488" font-weight="500" fill="#6A7C94">
                  <tspan x="10" y="19">?</tspan>
                </text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div
      v-if="showResults"
      class="z-10"
    >
      <ul
        class="list-reset bg-white rounded"
        :class="{'border-2' : showResults}">
          <li
            class="px-4 py-2 hover:bg-grey-lightest cursor-pointer relative"
            :class="{ 'is-active': index === arrowCounter }"
            v-for="(item, index) in addressResults"
            v-if="addressResults && addressResults.length > 0 && index <= 8"
            @click="parseAddress(item, index)"
            :key="item.RecordId">
            <img src="@/assets/location.svg" class="absolute" alt="location icon"/>
            <p class="ml-6">{{item.AddressLine}}, {{item.Locality}} {{item.State}} {{item.Postcode}}</p>
          </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import FieldText from './FieldText';

export default {
  components: {
    FieldText,
  },
  inject: ['$validator'],
  props: {
    namespace: {
      type: String,
    },
    id: {
      type: String,
    },
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldModel: {
      get() {
        return _.get(this.$store.state[this.namespace], this.field);
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
        this.addressAutocomplete(value);
      },
    },
  },
  data() {
    return {
      addressResults: [],
      showResults: false,
      arrowCounter: -1,
      addressToolTip: {
        content: '<h3>No Address Found</h3><br> Just enter the full address. <br><br>For example:<br>12 Smith St, Richmond, VIC 2131',
        trigger: 'click',
      },
    };
  },
  methods: {
    kleberEndpoint(value) {
      return `https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest?RequestKey=${
        'RK-D17DA-F4D67-ABD09-7A7FC-DBACC-2D257-EE6A9-7956B'
      }&OutputFormat=json&AddressLine=${value}&Method=DataTools.Capture.Address.Predictive.AuPaf.SearchAddress`;
    },
    detailedAddress(recordId) {
      return `https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest?RequestKey=${
        'RK-D17DA-F4D67-ABD09-7A7FC-DBACC-2D257-EE6A9-7956B'
      }&OutputFormat=json&RecordId=${recordId}&Method=DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress`
    },
    async addressAutocomplete(value) {
      // Hit the Kleber API and store results in `addressResults`
      const { data } = await axios.get(this.kleberEndpoint(value));

      this.addressResults = data.DtResponse.Result;

      // Show results if there are results and text in the input field is not empty
      this.showResults = this.addressResults.length && this.field.length;
    },
    async parseAddress(item, index) {
      // const Uppercase = (string) => {
      //   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      // }

      const { RecordId } = this.addressResults[index];

      const { data } = await axios.get(this.detailedAddress(RecordId));

      const { StreetNumber1, StreetName, StreetType, Locality, State, Postcode } = data.DtResponse.Result[0]

      const formattedAddress = `${StreetNumber1} ${StreetName} ${StreetType}, ${Locality}, ${State} ${Postcode}`;

      this.$store.commit(`${this.namespace}/setField`, {
        field: this.field,
        value: formattedAddress,
      });
      this.showResults = false;
    },
    // controls for autocomplete dropdown
    // - 'arrowCounter' determines which item in the list of results should be selected
    onArrowDown() {
      if (this.arrowCounter < this.addressResults.length) {
        this.arrowCounter++;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
      }
    },
    onEnter() {
      if (this.arrowCounter >= 0) {
        this.parseAddress(this.addressResults[this.arrowCounter]);
        this.showResults = false;
        this.arrowCounter = -1;
      }
    },
  },
};
</script>
<style lang="postcss">
@tailwind utilities;
.label {
  @apply .block .uppercase .tracking-wide .text-navy-light .text-xs .mb-2 .leading-normal;
}
.field {
  @apply .appearance-none .block .w-full .bg-grey-lighter .text-navy .border .rounded .py-3 .px-4;
}

.field-disabled {
  @apply .bg-grey;
}

.input-icon-position {
  left: 12px;
  top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldAddress2.vue